<template id="">
    <aside class="md:min-h-screen flex md:hidden flex-col items-center shadow aside--mobile">
        <ul class="w-full md:mt-20 flex md:block justify-center items-center py-2 py:md-0">
            <li class="px-4" v-if="profile.isSharpAdmin() ">
                <router-link
                        :to="{ name: 'adminClients' }"
                        active-class="active"
                        :class="{ active: isClientRoute }"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-users"></i>
                    <span class="text-sm mt-1">
                        Clients
                    </span>
                </router-link>
            </li>

            <li class="px-4" v-if="profile.isGroupAdmin()">
                <router-link
                        :to="{ name: 'groupAdminClients' }"
                        :class="{ active: isClientRoute }"
                        active-class="active"
                        exact-active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">

                    <i class="fas fa-users"></i>
                    <span class="text-sm mt-">
                        Clients
                    </span>
                </router-link>
            </li>


            <li class="px-4" v-if="profile.isSuperAdmin() ">
                <router-link
                        :to="{ name: 'staffManagement' }"
                        active-class="active"
                        exact-active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">

                    <i class="fas fa-user-shield"></i>
                    <span class="text-sm mt-1">
                        Staff
                    </span>
                </router-link>
            </li>

            <li class="px-4">
                <router-link
                        :to="{ name: 'profile' }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-cog"></i>
                    <span class="text-sm mt-1">
                        Profile
                    </span>
                </router-link>
            </li>

            <li class="px-4">
                <router-link
                        :to="{ name: 'signOut' }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-sign-out"></i>
                    <span class="text-sm mt-1">
                        Sign Out
                    </span>
                </router-link>
            </li>
        </ul>
    </aside>
</template>
<script charset="utf-8">
    import Vuex from 'vuex';

    export default {
        name: 'AdminMobileNav',
        data() {
            return {
                isActive: false
            }
        },
        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
            isClientRoute() {
                return this.$route.name == 'adminClientsAdd' ||
                    this.$route.name == 'adminClients';
            },
        },
        methods: {

        }
    }
</script>

